<template>
  <div v-show="message">
    <p class="text-sm text-red-600">
      {{ message ? message.replace(' id', '') : '' }}
    </p>
  </div>
</template>

<script>
export default {
  props: ['message'],
};
</script>
